import { render } from "./InstallationSection.vue?vue&type=template&id=c0528d18&ts=true"
import script from "./InstallationSection.vue?vue&type=script&lang=ts"
export * from "./InstallationSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__